import angular from 'angular';

const controllerInfo = {
    module: 'ib-carbon-footprint',
    inject: ['$rootScope'],
    required: []
};
export class ibToggleCo2SwitchController implements ng.IController {
    public focused = false;
    public text = '';
    constructor (private $rootScope: CommonsRootScope) { }

    applyPrice = (): void => {
        this.$rootScope.$broadcast('updateToggleCo2Modal');
    };

}


try {
    ibToggleCo2SwitchController.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(ibToggleCo2SwitchController.name, ibToggleCo2SwitchController);
} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    ibToggleCo2SwitchController.$inject = controllerInfo.inject;
    mod.controller(ibToggleCo2SwitchController.name, ibToggleCo2SwitchController);
}